<footer class="footer">
    <div class="footer-content justify-content-between">
        <p class="m-b-0">Transtecnia&reg; {{year}}.</p>
        <!-- <span>
            <a href="#" class="text-gray m-r-15">Términos &amp; Condiciones</a>
            <a href="#" class="text-gray">Política de Privacidad</a>
        </span> -->
    </div>
</footer>